import React from 'react';
import {
  DescTeamSection,
  DescTeamwrapper,
  StyledH2,
  ImageDesc,
} from './styles/index';

const TeamDesc = () => {
  return (
    <DescTeamSection>
      <DescTeamwrapper>
        <div>
          <StyledH2>Наші фахівці</StyledH2>
        </div>
        <p>
          Наша команда - це група пристрасних гастрономів, які працюють у
          кулінарії та індустрії гостинності. Кожен з нас володіє знаннями та
          досвід, що дозволяє нам створювати унікальні смакові відчуття для
          наших гостей. смакові враження для наших гостей. Ми зосереджуємося на
          якості та свіжості інгредієнтів, щоб наші страви завжди були
          ароматними та насиченими смаком. Наша робота заснована на пристрасті
          та задоволенні наших клієнтів, тому ми завжди намагаємося виправдати
          їхні очікування. ми завжди прагнемо відповідати їхнім очікуванням.
          Наша команда створює дружню атмосферу в нашому ресторані, яка змушує
          наших гостей відчувати себе особливо бажаними та цінними.
        </p>
      </DescTeamwrapper>
      <ImageDesc />
    </DescTeamSection>
  );
};

export default TeamDesc;
